export const daypartPairs = parts => Array.from({length:parts.length/2},(_,i)=>parts.slice(i*2,i*2+2));
const text = value => typeof value==='string'?value:value?.isValid()?value.format('HH:mm'):'';
export const formatDayparts = (parts, separator='~') => daypartPairs(parts).map(pair=>pair.map(text).join(separator)).join(', ');

export function getDaypartsError(parts) {
  if (!Array.isArray(parts) || parts.length<2 || parts.length%2) return '请填写完整的起止时间';
  const values=parts.map(text);
  if (values.some(value=>!/^([01]\d|2[0-3]):[0-5]\d$/.test(value))) return '请填写有效的起止时间';
  if (values.length===2) return '';
  let previousEnd=-1;
  for (const [start,end] of daypartPairs(values)) {
    const minute=value=>value==='23:59'?1440:Number(value.slice(0,2))*60+Number(value.slice(3));
    const a=Number(start.slice(0,2))*60+Number(start.slice(3)),b=minute(end);
    if (b<=a) return '多组时段须在同一天内，结束时间须晚于开始时间';
    if (a<previousEnd) return '请按时间先后排列，时段不能重叠';
    previousEnd=b;
  }
  return '';
}
